import { useEffect, useMemo } from "react";
import { MiButton, MiDetailPageHeader, MiTab } from "@miplatform/components";
import {
  BUTTON_VARIANTS,
  ENTITY_NAMES,
  ICONS_WEB,
} from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import * as mdi from "@mdi/js";
import { WorkOrderTemplateAssignmentTemplateModal } from "./WorkOrderTemplateAssignmentTemplateModal";
import { AssignmentTemplatesTab, Details } from "./tabs";
import { useWorkOrderTemplateViewModel } from "./useWorkOrderTemplateViewModel";

const ROUTE_NAMES = {
  DETAILS: "details",
  INPUT_OPTIONS: "input-options",
  TEMPLATES: "assignment-templates",
  HOLD_REASONS: "hold-reasons",
};

const TAB_NAMES = {
  DETAILS: "Details",
  INPUT_OPTIONS: "Input Options",
  TEMPLATES: "Assignment Templates",
  HOLD_REASONS: "Hold Reasons",
};

const TAB_LIST = [
  {
    name: TAB_NAMES.DETAILS,
    value: ROUTE_NAMES.DETAILS,
    label: TAB_NAMES.DETAILS,
  },
  {
    name: TAB_NAMES.TEMPLATES,
    value: ROUTE_NAMES.TEMPLATES,
    label: TAB_NAMES.TEMPLATES,
  },
];

export function WorkOrderTemplate() {
  const router = useRouter();
  const { id: workOrderTemplateId, activeTab } = router.params;

  const {
    workOrderTemplate,
    loading,
    isModalOpen,
    getAllAssignmentTemplates,
    handleAddAssignmentTemplate,
    closeModal,
    openModal,
    getWorkOrderTemplateDetails,
    onDetailsUpdate,
    getTrades,
    trades,
  } = useWorkOrderTemplateViewModel({ workOrderTemplateId });

  useEffect(() => {
    getWorkOrderTemplateDetails();
    getTrades();
  }, [workOrderTemplateId]);

  const actionComponent = useMemo(() => {
    switch (activeTab) {
      case ROUTE_NAMES.TEMPLATES:
        return (
          <MiButton
            startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
            variant={BUTTON_VARIANTS.CONTAINED}
            onClick={openModal}
            data-testid="add-btn"
            title="Add Assignment Template"
          />
        );
      default:
        return null;
    }
  }, [activeTab]);

  const handleTabChange = (tab) => {
    router.navigate(
      `/settings/order-management/work-order-types/${workOrderTemplateId}/${tab}`
    );
  };

  const customOnBack = () => {
    router.navigate(`/settings/order-management/work-order-types`);
  };
  return (
    <>
      <MiDetailPageHeader
        loading={loading}
        title={`${ENTITY_NAMES.WORK_ORDER_TEMPLATE}: ${
          workOrderTemplate?.name || ""
        }`}
        titleIcon={mdi[ICONS_WEB.CHEVRON_LEFT]}
        actionComponent={actionComponent}
        customOnBack={customOnBack}
      />
      <MiTab
        tabs={TAB_LIST}
        currentTab={activeTab}
        onTabChange={handleTabChange}
      />
      {activeTab === ROUTE_NAMES.DETAILS && (
        <Details
          workOrderTemplate={workOrderTemplate}
          trades={trades}
          onUpdate={onDetailsUpdate}
        />
      )}
      {activeTab === ROUTE_NAMES.TEMPLATES && (
        <AssignmentTemplatesTab
          workOrderTemplate={workOrderTemplate}
          refresh={getWorkOrderTemplateDetails}
        />
      )}
      <WorkOrderTemplateAssignmentTemplateModal
        open={isModalOpen}
        getAllAssignmentTemplates={getAllAssignmentTemplates}
        title="Add Assignment Template"
        buttonTitle="Submit"
        onClose={closeModal}
        onSubmit={handleAddAssignmentTemplate}
      />
    </>
  );
}
